// src/pages/TrialExpiredPage.js
import React from 'react';
import "./TrialExpiredPage.css";
import { useNavigate } from 'react-router-dom';

function TrialExpiredPage() {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate('/login', { replace: true });
  };

  return (
    <div
      className="trial-bg"
      style={{
        minHeight: '100vh',
        background: '#ffffff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '16px',
        position: 'relative',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 540,
          padding: '20px 20px 24px',
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          zIndex: 1,
        }}
      >
        {/* RUBRIK – neutral */}
        <h1
          style={{
            fontSize: 28,
            textAlign: 'center',
            margin: 0,
            color: '#047857',
            fontWeight: 800,
          }}
        >
          Åtkomst begränsad
        </h1>

        {/* ÖVERSTA CARD – förklaring + kontakt (mild) */}
        <div
          style={{
            background: '#f9fafb',
            borderRadius: 18,
            border: '1px solid #e5e7eb',
            padding: '14px 16px',
            fontSize: 15,
            lineHeight: 1.7,
            color: '#111827',
          }}
        >
          <p style={{ margin: 0, marginBottom: 8 }}>
            Den här funktionen är för närvarande inte tillgänglig i ert konto.
            Ni har nått gränsen för hur många transporter som kan skickas med
            nuvarande åtkomstnivå.
          </p>
          <p style={{ margin: 0, fontSize: 13, color: '#4b5563' }}>
            För att få fortsatt åtkomst till att skicka transporter, vänligen
            kontakta oss via{' '}
            <a
              href="https://www.smartavfallsapp.se"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#047857',
                fontWeight: 600,
                textDecoration: 'none',
              }}
            >
              smartavfallsapp.se
            </a>{' '}
            eller via er ordinarie kontaktväg.
          </p>
        </div>

        {/* NEDRE DEL – pelikan + card till höger */}
        <div
          style={{
            display: 'flex',
            gap: 16,
            alignItems: 'flex-start',
            marginTop: 2,
          }}
        >
          {/* PELIKAN – med neutral alt-text */}
          <img
            src="/Trialexpiredpelikan.png"
            alt="Åtkomst begränsad"
            style={{
              width: 230,
              height: 'auto',
              flexShrink: 0,
              marginLeft: -65,
            }}
          />

          {/* SMALT CARD TILL HÖGER – neutral info om aktivt konto */}
          <div
            style={{
              background: '#f9fafb',
              borderRadius: 18,
              border: '1px solid #e5e7eb',
              padding: '12px 14px',
              fontSize: 14,
              lineHeight: 1.6,
              color: '#111827',
              flex: 1,
              maxHeight: 230,
              overflow: 'hidden',
            }}
          >
            <p style={{ marginTop: 0, marginBottom: 6 }}>
              Med ett aktivt företagskonto kan ni bland annat:
            </p>
            <ul style={{ paddingLeft: 18, margin: 0 }}>
              <li>Skicka transporter till Naturvårdsverket via appen</li>
              <li>Få säker lagring av transporter och relaterad information</li>
            </ul>
          </div>
        </div>

        {/* KNAPP – neutral text */}
        <button
          type="button"
          onClick={handleGoToLogin}
          style={{
            padding: '13px 16px',
            borderRadius: 999,
            border: 'none',
            background: '#16a34a',
            color: '#ffffff',
            fontWeight: 700,
            fontSize: 15,
            cursor: 'pointer',
            marginTop: -50,
            alignSelf: 'center',
            minWidth: 260,
          }}
        >
          Tillbaka till inloggning
        </button>
      </div>
    </div>
  );
}

export default TrialExpiredPage;
